import { render, staticRenderFns } from "./chatReclamo.vue?vue&type=template&id=41347248&scoped=true"
import script from "./chatReclamo.vue?vue&type=script&lang=js"
export * from "./chatReclamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41347248",
  null
  
)

export default component.exports